<ng-container *ngIf="getEnvName() as env">
  <div
    matTooltip="Won't show up in prod, just for internal use"
    class="environment-switcher w-full h-full rounded-lg flex flex-col items-center justify-center font-bold text-black"
    [class.bg-red-500]="env === 'Prod'"
    [class.opacity-25]="env !== 'Prod'"
    [matMenuTriggerFor]="menu"
  >
    <div>Using {{ env }}</div>
    <div>({{ flagEnv$ | async }} 🏁)</div>
  </div>
</ng-container>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="this.featureFlagService.useStageFlags()">
    <mat-icon *ngIf="(flagEnv$ | async) === 'Stage'">check</mat-icon>Stage Flags
  </button>
  <button mat-menu-item (click)="this.featureFlagService.useProdFlags()">
    <mat-icon *ngIf="(flagEnv$ | async) === 'Prod'">check</mat-icon>Prod Flags
  </button>
</mat-menu>
